import { render, staticRenderFns } from "./HostAfricaServerPricing.vue?vue&type=template&id=02a60234&scoped=true&"
import script from "./HostAfricaServerPricing.vue?vue&type=script&lang=js&"
export * from "./HostAfricaServerPricing.vue?vue&type=script&lang=js&"
import style0 from "./HostAfricaServerPricing.vue?vue&type=style&index=0&id=02a60234&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a60234",
  null
  
)

export default component.exports